"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const iconoir_react_1 = require("iconoir-react");
// import app components
const colors_1 = __importDefault(require("../../../theme/colors"));
const paper_1 = __importDefault(require("../paper"));
const Dialog = (props) => {
    const { open, title, children, actions, maxWidth, onClose, ...rest } = props;
    return (react_1.default.createElement(material_1.Dialog, { open: open, onClose: onClose, scroll: "body", PaperProps: {
            sx: {
                background: colors_1.default.secondary[800],
            },
        }, maxWidth: maxWidth, ...rest },
        react_1.default.createElement(paper_1.default, { sx: {
                position: "relative",
                display: "flex",
                flexDirection: "column",
                p: { xs: "12px", sm: "24px" },
            }, level: 2 },
            title && (react_1.default.createElement(material_1.DialogTitle, { variant: "h3", sx: { display: "flex", placeContent: "space-between" } }, title)),
            onClose && typeof onClose === "function" && (react_1.default.createElement(material_1.IconButton, { onClick: onClose, sx: { position: "absolute", top: "15px", right: "15px", background: colors_1.default.secondary[800] } },
                react_1.default.createElement(iconoir_react_1.Cancel, { color: colors_1.default.icons[700], width: "1.2rem", height: "1.2rem" }))),
            children && react_1.default.createElement(material_1.DialogContent, { sx: { p: { xs: "12px", sm: "20px 24px" } } }, children),
            actions && react_1.default.createElement(material_1.DialogActions, { sx: { p: { xs: "12px", sm: "20px 24px" } } }, actions))));
};
exports.default = Dialog;
